<p-dataView
  #dv
  [value]="dataSource ? (dataSource.results ? dataSource.results : []) : []"
  [lazy]="
    configuration ? (configuration.lazy ? configuration.lazy : false) : false
  "
  [emptyMessage]="'No se encontraron cajas'"
  [paginator]="
    configuration
      ? configuration.paginator
        ? configuration.paginator
        : false
      : false
  "
  [rows]="configuration ? (configuration.rows ? configuration.rows : 0) : 0"
  [totalRecords]="dataSource ? (dataSource.count ? dataSource.count : 0) : 0"
  [layout]="'list'"
  [styleClass]="
    configuration
      ? configuration.styleClass
        ? configuration.styleClass
        : ''
      : ''
  "
  [loading]="loading"
  [lazyLoadOnInit]="false"
  (onLazyLoad)="loadLazy($event)"
>
  <p-header>
    <div class="flex justify-content-between">
      <span class="text-lg">{{
        configuration
          ? configuration.title
            ? configuration.title
            : ''
          : ('' | translate)
      }}</span>
      <p-dataViewLayoutOptions />
    </div>
    <div class="p-1">
      <div>
        <p-inputGroup>
          <input
            pInputText
            type="text"
            placeholder="{{ 'Buscar' | translate }}..."
            [(ngModel)]="searchPackageValue"
            (keyup)="onCompleteSearch($event)"
          />
          <p-inputGroupAddon>
            <i class="pi pi-search"></i>
          </p-inputGroupAddon>
        </p-inputGroup>
      </div>
    </div>
    <div class="flex justify-content-center flex-wrap">
      <span
        >{{ countPacket | number }}
        <span class="text-xs">{{ 'Cajas' | translate }}</span></span
      >
      <span class="pr-1 pl-1">|</span>
      <span
        >{{ countItems | number }}
        <span class="text-xs">{{ 'Items x Página' | translate }}</span></span
      >
    </div>
  </p-header>

  <ng-template let-packs pTemplate="list">
    @for (pack of packs; track $index) {
    <div
      class="flex justify-content-between flex-wrap rowPackDataList col-12"
      (click)="selectPack(pack)"
    >
      <div class="col-3 flex justify-content-center flex-wrap">
        <i
          class="pi pi-box"
          [ngStyle]="{ color: configuration?.cube?.color }"
          style="font-size: 36px; text-align: center"
        ></i>
      </div>

      <div class="col-9 flex flex-column">        
        @if (pack['work_order'] && pack['work_order']['destination']) {
        <h4 class="text-lg">
          {{
            pack['work_order']['destination']['display_name'] ||
              pack['work_order']['destination']['name']
          }}
        </h4>
        }
        <div>
          <span class="text-cyan-700 text-lg" *ngIf="pack.prefix"
            >{{ pack.prefix }}-</span
          >
          <span class="text-cyan-700 text-lg">{{ pack.id }}</span>
          <span
            class="text-800"
            *ngIf="
              configuration &&
              configuration.cube &&
              configuration.cube.external_id
            "
          >
            | #{{ pack[configuration.cube.external_id] }}</span
          >
        </div>
        <div>
          <span class="text-700"
            >{{ 'Total' | translate }}: {{ pack.total_amount | number }}
            {{ 'Items' | translate }}</span
          >
        </div>
        <div>
          <span class="text-700">{{ pack.modified }}</span>
        </div>
      </div>
    </div>
    }
  </ng-template>
  <ng-template let-packs pTemplate="grid">
    <div class="grid">
      @for (pack of packs; track $index) {
      <div class="col-12 md:col-6 lg:col-6">
        <p-panel
          [header]="pack.prefix + '-' + pack.id"
          [style]="{ 'text-align': 'center' }"
        >
          <i
            class="pi pi-box"
            [ngStyle]="{ color: configuration?.cube?.color }"
            style="font-size: 36px; text-align: center"
          ></i>
          <div class="pack-detail">
            <label class="text-700"
              >{{ 'Total' | translate }}:
              {{
                envService.environment?.isQuantity
                  ? pack.total_quantities
                  : (pack.total_amount | number)
              }}
              {{ 'Items' | translate }}</label
            >
            <div class="col-lg-12 col-md-12 col-xs-12">
              <label class="text-700">{{ pack.modified }}</label>
            </div>
          </div>
          <hr class="ui-widget-content" style="border-top: 0" />
          <button
            pButton
            type="button"
            icon="pi pi-eye"
            (click)="selectPack(pack)"
            style="margin-top: 0"
          ></button>
        </p-panel>
      </div>
      }
    </div>
  </ng-template>
</p-dataView>
